export enum BusyBottomConfig {
  GENERAL = 'GENERAL',
  METAMASK_SIGN = 'METAMASK_SIGN',
  METAMASK_UNLOCK = 'METAMASK_UNLOCK',
  GENERIC_WEB3 = 'GENERIC_WEB3',
  LEDGER = 'LEDGER',
  TREZOR = 'TREZOR',
  GRIDPLUS = 'GRIDPLUS',
  WALLETCONNECT = 'WALLETCONNECT',
  SUPPORT = 'SUPPORT',
  OFFLINE = 'OFFLINE'
}
